var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.white ? 'white-color' : ''},[_c('h2',{attrs:{"title":_vm.titleName}},[_c('span',{staticClass:"head"},[_vm._v(_vm._s(_vm.head))]),_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }